import { defineStore } from 'pinia'
import type { UserBankItem } from '~/composables/account/interface'

interface UserBanksState {
  userMainBanks: UserBankItem[]
}
const STORE_NAME = 'userMainBanks'

export const useUserBanksStore = defineStore(STORE_NAME, {
  state: (): UserBanksState => ({
    userMainBanks: []
  }),
  persist: false,
  actions: {
    setUserMainBank(banks: UserBankItem[]) {
      this.userMainBanks = banks
    }
  }
})
